// actions
export const SET_REALTIME_STATUS = 'settings/realtime-status-update';

// action creators
export const setRealtimeStatus = (active) => ({
  type: SET_REALTIME_STATUS,
  active
});
